<template>
<router-view />
</template>

<script>
export default {
  name: 'VOCs',
  routeInfo: {
    label: 'VOCs',
    icon: 'fa fa-line-chart'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/00VOCs/index.vue